export const ADMIN_LANGUAGES = [
    { code: "ro", suffix: "", label: "ROM", name: "română" },
    { code: "ru", suffix: "_ru", label: "RUS", name: "rusă" },
    { code: "en", suffix: "_en", label: "ENG", name: "engleză" },
];

export function getAdminLanguage(code) {
    return ADMIN_LANGUAGES.find((language) => language.code === code) || ADMIN_LANGUAGES[0];
}

/**
 * Language switcher for the admin forms. `values` is the edited record and `fields` the base
 * field names; a tab gets a dot when one of its fields is still empty while the Romanian one is filled.
 */
function LanguageTabs({ active, onChange, values = {}, fields = [], ariaLabel = "Limbi" }) {
    const isIncomplete = (language) =>
        language.suffix !== "" &&
        fields.some(
            (field) =>
                String(values[field] || "").trim() !== "" && String(values[`${field}${language.suffix}`] || "").trim() === "",
        );

    return (
        <div className="admin__language-tabs" role="tablist" aria-label={ariaLabel}>
            {ADMIN_LANGUAGES.map((language) => (
                <button
                    key={language.code}
                    type="button"
                    role="tab"
                    aria-selected={active === language.code}
                    className={`admin__language-tab ${active === language.code ? "active" : ""}`}
                    onClick={() => onChange(language.code)}>
                    {language.label}
                    {isIncomplete(language) && (
                        <span className="admin__language-tab-missing" title="Traducere lipsă">
                            •
                        </span>
                    )}
                </button>
            ))}
        </div>
    );
}

export default LanguageTabs;
